import { render, staticRenderFns } from "./PageLocker.vue?vue&type=template&id=aae1a82a&"
import script from "./PageLocker.vue?vue&type=script&lang=js&"
export * from "./PageLocker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports